import { render, staticRenderFns } from "./StatusMonitor.vue?vue&type=template&id=0f006c6d&scoped=true&"
import script from "./StatusMonitor.vue?vue&type=script&lang=js&"
export * from "./StatusMonitor.vue?vue&type=script&lang=js&"
import style0 from "./StatusMonitor.vue?vue&type=style&index=0&id=0f006c6d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f006c6d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
